module.exports = __webpack_public_path__ + "static/media/connector_icon_airflow.9805fa6c.svg";